import blocks from '@blocks';
import useEditorTheme from '@hooks/useEditorTheme';
import { transformTheme } from '@Utils/data';

const Element = props => {
    const { EditorElement } = blocks[props.element.type] || blocks.error;
    const theme = useEditorTheme();
    const themedElement = transformTheme(props.element, theme);

    return <EditorElement {...props} element={themedElement} />;
};

export default Element;
